import { proxy } from "valtio";
import type { ChatState } from "../types";

export const ChatStore = proxy<ChatState>();
